export let state = {
    isFilterActive: false
}
